import React, { useState, useEffect } from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface CustomDayPickerProps
  extends Omit<ReactDatePickerProps, "selected" | "onChange"> {
  selectedDate: Date;
  onChange: (date: Date) => void;
  datePickername?: string;
  name?: string;
  defaultDate: Date;
  error?: string;
  setError?: React.Dispatch<string>;
}

const CustomDayPicker = ({
  selectedDate,
  onChange,
  name,
  defaultDate,
  error,
  setError,
  ...restProps
}: CustomDayPickerProps) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  useEffect(() => {
    // When an error occurs, reset the input focus
    if (error) {
      setIsInputFocused(false);
    }
  }, [error]);

  const formattedDate = defaultDate
    .toLocaleDateString("he-IL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .split(".")
    .join("/");

  const handleOnBlur = () => {
    setIsInputFocused(false);
  };

  const handleInputFocus = () => {
    setError("");
    setIsInputFocused(true);
  };

  return (
    <DatePicker
      name={name}
      selected={selectedDate}
      onChange={(value) => {
        setIsInputFocused(false);
        onChange(value);
      }}
      dateFormat="dd/MM/yyyy"
      maxDate={new Date()}
      showMonthDropdown
      showYearDropdown
      placeholderText={isInputFocused ? "" : formattedDate}
      onBlur={handleOnBlur}
      onFocus={handleInputFocus}
      className="custom-datepicker"
      {...restProps}
    />
  );
};

export default CustomDayPicker;
